/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { NavLink } from 'react-router-dom';
import iconPlayStore from '../../assets/google-play-badge.png';
import iconAppStore from '../../assets/apple-app-badge.png';
import {
  Content,
  Menu,
  Left,
  Right,
  Contact,
  Numbers,
  DownloadStore,
  Regions,
  Hour,
} from './styles';

const Footer: React.FC = () => {
  return (
    <Content>
      <Menu>
        <Left>
          <nav>
            <div className="menu_nav">
              <NavLink exact to="/contract">
                Proposta
              </NavLink>
              <NavLink exact to="/help">
                Central de Ajuda
              </NavLink>
              <NavLink exact to="/about">
                Fale Conosco
              </NavLink>
            </div>
          </nav>
        </Left>
        <Right>
          <Contact>
            <Numbers>
              <Regions>
                <label htmlFor="n1">Regiões Metropolitanas</label>
                <strong id="n1">3004-9680</strong>
              </Regions>
              <Regions>
                <label>Demais Regiões</label>
                <strong>0800-326-0506</strong>
              </Regions>
            </Numbers>
            <Hour>
              <p>Atendimento 24h todos os dias</p>
            </Hour>
          </Contact>
          <DownloadStore>
            <a href="https://apps.apple.com/us/app/stone-portal/id1196425762">
              <img src={iconAppStore} alt="AppStore" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.portal.android">
              <img src={iconPlayStore} alt="PlayStore" />
            </a>
          </DownloadStore>
        </Right>
      </Menu>
    </Content>
  );
};

export default Footer;
